module.exports = __webpack_public_path__ + "img/add_user.5b50fd53.png";